import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import './libs/permissions'

import moment from 'moment-timezone'
import router from './router'
import i18n from './i18n/i18n'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'


// font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

//FontAwesome
library.add(fas)
Vue.component('fa', FontAwesomeIcon)

// axios
import '@/libs/axios'

// localize
import {localize} from 'vee-validate'
localize('sl')

// Moment.js
moment.tz.setDefault('SI')
Vue.prototype.moment = moment

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.prototype.$printError = function(error) {
  this.$toast({
    component: ToastificationContent,
    props: {
      icon: 'DangerOctagonIcon',
      title: error,
      variant: 'danger'
    }
  })
}

Vue.prototype.$printWarning = function(message) {
  this.$toast({
    component: ToastificationContent,
    props: {
      icon: 'AlertTriangleIcon',
      title: message,
      variant: 'warning'
    }
  })
}

Vue.prototype.$printSuccess = function(message) {
  this.$toast({
    component: ToastificationContent,
    props: {
      icon: 'CheckCircleIcon',
      title: message,
      variant: 'success'
    }
  })
}

Vue.prototype.$convertPriceIntegerToFloat = function(price) {
  if (!price) return (0).toFixed(2)
  return (price / 100).toFixed(2)
}

async function init() {
  const store = (await import('@/store')).default
  const App = (await import('@/App.vue')).default

  const userDataString = localStorage.getItem('userData')
  if (userDataString && userDataString !== 'undefined') {
    store.state.user.userData = JSON.parse(userDataString)
  }

  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

void init()